import React from 'react'
import {instance as elementTypeService} from '../../services/ElementTypeService'
import {CanvasEditorForElementsStep} from './CanvasEditorForElementsStep'

export function CanvasEditorHardscape() {
  return (
    <CanvasEditorForElementsStep
      availableElementTypes={elementTypeService.getHardscapeElementTypes()}
    />
  )
}
